export default {
    '2022':[
        'WhatsApp Image 2022-06-01 at 2.52.01 PM.jpeg',
    ],
    '2021':[
        'WhatsApp Image 2021-12-17 at 5.19.04 PM.jpeg',
        'WhatsApp Image 2021-12-20 at 3.27.05 PM.jpeg',
        'WhatsApp Image 2021-11-11 at 1.04.08 PM.jpeg',
        'WhatsApp Image 2021-10-26 at 6.03.10 PM.jpeg',
        'WhatsApp Image 2021-10-25 at 5.11.05 PM.jpeg',
        'WhatsApp Image 2021-08-06 at 11.49.29 AM.jpeg',
        'WhatsApp Image 2021-08-06 at 11.49.23 AM.jpeg',
        'WhatsApp Image 2021-05-10 at 7.03.03 AM.jpeg',
        'WhatsApp Image 2021-05-07 at 10.26.53 PM.jpeg',
        'WhatsApp Image 2021-04-28 at 12.48.24 AM.jpeg',
        'WhatsApp Image 2021-02-17 at 1.14.56 PM.jpeg',
        'WhatsApp Image 2021-02-09 at 7.14.30 PM.jpeg',
    ],
    '2020':[
        'WhatsApp Image 2021-01-26 at 11.42.40 PM.jpeg',
        'WhatsApp Image 2021-04-13 at 12.39.39 PM.jpeg',
        'WhatsApp Image 2021-08-04 at 7.56.18 PM.jpeg',
        'WhatsApp Image 2020-09-25 at 2.28.15 PM.jpeg',
        'flower4.jpg',
        'flower3.jpg',
        'flower2.jpeg',
        'flower.jpg',
        'leopard.jpeg',
        'IMG-20210106-WA0000.jpg',
        'IMG-20201130-WA0000.jpg',
        'IMG-20200902-WA0000.jpg',
    ],
    '2019':[
        'tiger.jpg',
        'birds2.jpeg',
        'birds.jpeg',
        'new_fish.jpeg',
    ],
    '2018':[
        'WhatsApp Image 2022-06-15 at 6.18.56 PM.jpeg',
        'pond.jpg',
        'desert.jpg',
        'ocean.jpg',
        'koi.jpg',
    ],
};